"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _FooterBar = require("./FooterBar");
var _FooterSection = require("./FooterSection");
var _Grid = require("../Grid");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _footerModule = _interopRequireDefault(require("@albelli/arc-3/lib/footer.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Footer = _ref => {
  var _storefrontConfig$men, _storefrontConfig$men2;
  let {
    storefrontConfig,
    vendor,
    vendorLinks
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _footerModule.default["arc3-footer"],
    "data-cy": "arc3-footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "arc3-container"
  }, /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
    container: true
  }, storefrontConfig === null || storefrontConfig === void 0 || (_storefrontConfig$men = storefrontConfig.menus) === null || _storefrontConfig$men === void 0 || (_storefrontConfig$men = _storefrontConfig$men.footer) === null || _storefrontConfig$men === void 0 ? void 0 : _storefrontConfig$men.map((footerItem, index) => /*#__PURE__*/_react.default.createElement(_FooterSection.FooterSection, _extends({
    key: index,
    index: index
  }, footerItem))))), /*#__PURE__*/_react.default.createElement(_FooterBar.FooterBar, {
    links: storefrontConfig === null || storefrontConfig === void 0 || (_storefrontConfig$men2 = storefrontConfig.menus) === null || _storefrontConfig$men2 === void 0 ? void 0 : _storefrontConfig$men2.bottom,
    copyright: storefrontConfig === null || storefrontConfig === void 0 ? void 0 : storefrontConfig.copyright,
    vendor: vendor,
    vendorLinks: vendorLinks
  }));
};
exports.Footer = Footer;
Footer.propTypes = {
  /** Public Storefront configuration object */
  storefrontConfig: _propTypes.default.object,
  /** Current vendor. i.e. 'bonusprint.co.uk' */
  vendor: _propTypes.default.string,
  /** vendor keyed object with the url specified for each vendor flag */
  vendorLinks: _propTypes.default.object
};